import styled from 'styled-components'
import {device} from '../../../../theme'

export const OurServicesWrap = styled.div `
    margin-top: 70px;
    @media ${device.small}{
        margin-top: 50px;
    }
`;